import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import type { NotificationItem } from '../../../lib/teacherApi';

export default function ParentNotificationsCard({
  notifications,
  onReload,
  onMarkAllRead,
  onOpenAll,
  onOpen,
}: {
  notifications: NotificationItem[];
  onReload: () => Promise<void>;
  onMarkAllRead: () => Promise<void>;
  onOpenAll: () => void;
  onOpen: (n: NotificationItem) => void;
}) {
  const unread = notifications.filter((n) => !n.is_read).length;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Notificări</h3>
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full sm:w-auto">
          <Button variant="ghost" size="sm" iconName="RefreshCw" onClick={onReload} className="w-full sm:w-auto">
            Reîncarcă
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="CheckCheck"
            onClick={onMarkAllRead}
            disabled={unread === 0}
            className="w-full sm:w-auto"
          >
            Marchează citite
          </Button>
        </div>
      </div>

      {notifications.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8">
          <Icon name="BellOff" size={48} className="text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground text-center">Nu există notificări</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notifications.slice(0, 8).map((n) => (
            <button
              key={n.id}
              onClick={() => onOpen(n)}
              className={`w-full text-left p-3 border border-border rounded-md hover:bg-muted/40 transition-colors ${
                !n.is_read ? 'bg-muted/30' : ''
              }`}
            >
              <div className="flex items-start gap-2">
                <Icon name="Bell" size={16} className="text-muted-foreground mt-0.5" />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <div className="text-sm font-medium text-foreground truncate">{n.title}</div>
                    <div className="text-[11px] text-muted-foreground whitespace-nowrap">
                      {new Date(n.created_at).toLocaleString()}
                    </div>
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground line-clamp-2">{n.content}</div>
                </div>
              </div>
            </button>
          ))}
          <Button variant="outline" size="sm" fullWidth iconName="ArrowRight" iconPosition="right" onClick={onOpenAll}>
            Vezi toate
          </Button>
        </div>
      )}
    </div>
  );
}
